<table>

  {#each reportSections as sect}
    <tr>
      <th class="header"><b>{sect.label}</b></th>
      <!-- <th class="header">{sect.type}</th> -->
      <th class="header">
        <span on:click={() => selectedIt(sect.property)}>
          {selection[sect.property] ? 'Si': 'No'} 
        </span>          
      </th>
      <th class="header">{sect.property}</th>
    </tr>

    {#each sect.controls as ctrl}
      <tr style="margin-top:2px;">
        <td>{ctrl.label}</td>
        <td>
          <span on:click={() => selectedIt(ctrl.property)}>
            {selection[ctrl.property] ? 'Si': 'No'} 
          </span>          
        </td>
        <td>{ctrl.property}</td>
        <!-- <td>{ctrl.type}.{ctrl.subtype || ''}</td> -->
      </tr>
    {/each}

  {/each}
</table>

<script>
  import { onMount } from 'svelte'
  import { cloned } from '@/helpers'
  import { RecordDef, is } from '@/models'

  export let 
    meta = {},
    selection = {};

  let reportSections = [];

  onMount(() => {
    reportSections = buildReport(meta)
  })

  function buildReport(meta) {
    let rpt = [];
    let sections = meta && meta.sections;
    
    (sections || []).map((section) => {
      selection[section.property] = !(selection[section.property] || false);
      rpt.push({ 
        property: section.property,
        label: section.label,
        type: section.type,
        controls:  (section.controls || []).map((ctrl) => resumeField(ctrl))
      })
    });

    return rpt;
  }

  function resumeField(field) {
    selection[field.property] = !(selection[field.property] || false);
    return ({
      property: field.property,
      label: field.label,
      type: field.type,
      subtype: field.options && field.options.subtype || '',
      domain: (field.domain ? JSON.stringify(field.domain) : '')
    })
  }

  function selectedIt(prop) {
    selection[prop] = !(selection[prop] || false);
  }

</script>

<style>
  .header {
    text-align: left;
    padding-top: 1.6rem;
    font-size: 16px;
  }

  .subheader {
    text-align: left;
    padding-top: 8px;
    color: #999;
    font-size: 12px;
    font-weight: normal;
  }

  td {
    font-size: 15px;
    padding-top: 4px;
    padding-bottom: 4px;
    border-bottom: 1px solid #ccc;
  }
</style>